var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news_page"},[_c('DashHeader'),_c('Gauges'),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("BACK")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }